module.exports = __webpack_public_path__ + "assets/fonts/GothamPro.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro.woff
// module id = 682
// module chunks = 0